module.exports = __webpack_public_path__ + "7ad89ea42aee49803f57d69eac4e4c9a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-27.png
// module id = 3323
// module chunks = 0